<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="banner mb12">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(i, v) in pictureList" :key="v"
          ><img style="width: 100%; height: 100%" :src="i.url" alt=""
        /></van-swipe-item>
      </van-swipe>
    </div>
    <!-- 金刚区 -->
    <div class="flexb tabsBox mb12">
      <!-- <div class="tabs" @click="getAll()">
        <img
          src="@/static/imgs/all.png"
          alt=""
          style="width: 40px; height: 40px; margin-bottom: 6px"
        />
        全国靓号
      </div> -->
      <div class="tabs" @click="getLocal()">
        <img
          src="@/static/imgs/local.png"
          alt=""
          style="width: 40px; height: 40px; margin-bottom: 6px"
        />本地靓号
      </div>
      <div class="tabs" @click="getPhone()">
        <img
          src="@/static/imgs/customer.png"
          alt=""
          style="width: 40px; height: 40px; margin-bottom: 6px"
        />客户服务
      </div>
      <div class="tabs" @click="complaint()">
        <img
          src="@/static/imgs/complaint.png"
          alt=""
          style="width: 40px; height: 40px; margin-bottom: 6px"
        />反馈投诉
      </div>
    </div>
    <div class="main">
      <!-- 搜索 -->
      <div class="search flex mb12">
        <input
          type="text"
          class="searchIpt"
          v-model="params.phone"
          placeholder="输入您喜欢的号码"
        />
        <van-icon name="search" size="24" @click="searchTel()" />
      </div>
      <!-- 排序 -->
      <div class="flexa sort mb12">
        <div @click="getBelongingPlace()">
          {{ params.city }}
          <van-icon name="play" style="transform: rotate(90deg)" />
        </div>
        <!-- <div @click="getPriceSort()">
          {{ priceSortText }}

          <van-icon name="play" style="transform: rotate(90deg)" />
        </div> -->
        <div @click="typeShow = true">
          号码筛选
          <van-icon name="play" style="transform: rotate(90deg)" />
        </div>
      </div>
      <!-- 号码 -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="暂无数据"
        loading-text="加载中..."
        @load="onLoad()"
        :offset="350"
      >
        <div class="flexb phones">
          <div
            class="lists mb12"
            v-for="(i, v) in phoneList"
            :key="v"
            @click="goDetail(i)"
          >
            <span class="liang flexc">靓</span>
            <div
              style="
                font-size: 19px;

                font-weight: 600;
              "
            >
              <span>{{ i.phone.substr(0, 3) || "" }}-</span>
              <span>{{ i.phone.substr(3, 4) || "" }}-</span>
              <span class="font-color">{{ i.phone.substr(7, 11) || "" }}</span>
            </div>
            <!-- <div class="belong">{{ i.city }} | {{ i.brand }}</div> -->
            <div class="belong">{{ i.province }} | {{ i.city }}</div>
            <div class="price font-color">
              ￥<span>{{ i.tgprice / 100 }}</span>
              <!--  <span
                style="
                  text-decoration: line-through;
                  color: #999;
                  margin-left: 8px;
                  font-size: 14px;
                  font-weight: normal;
                "
                >￥{{ i.tgprice * 0.03 }}</span
              > -->
            </div>
          </div>
        </div></van-list
      >
    </div>
    <!-- 选择归属地 -->
    <van-popup
      v-model="belongingPlaceShow"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-area
        title="选择所在地区"
        :area-list="areaList"
        :columns-num="2"
        :value="citycode"
        @confirm="belongingPlaceConfirm"
        @cancel="belongingPlaceCancel"
    /></van-popup>
    <!-- 号码排序 -->
    <van-popup
      v-model="priceSortShow"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        title="选择排序方式"
        show-toolbar
        :columns="priceSort"
        @confirm="priceSortonConfirm"
        @cancel="priceSortonCancel"
      />
    </van-popup>
    <!-- 号码筛选 -->
    <van-popup v-model="typeShow" position="bottom" :closeable="true">
      <!-- phoneType -->
      <div class="types">
        <div class="typeTitle">号码类型</div>
        <div class="flex mb12" style="flex-wrap: wrap">
          <div
            class="typeItem"
            :class="{ active: activeIdx == v }"
            v-for="(i, v) in phoneType"
            :key="'a' + v"
            @click="typeActive(i, v)"
          >
            {{ i }}
          </div>
        </div>
        <div class="flexb typeBtn">
          <div
            class="flexc"
            style="color: #333; background-color: #f1f1f1"
            @click="typeShow = false"
          >
            取消
          </div>
          <div class="flexc" @click="typeSearch()">搜索</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  phoneLists,
  details,
  queryConfigByPlatform,
  address,
  queryAddressList,
} from "@/request/api";
import { areaList } from "@vant/area-data";

export default {
  name: "HomeView",
  data() {
    return {
      search: "",
      phoneList: [],
      params: {
        pageNum: 1,
        pageSize: 12,
        channel: 1,
        phone: "",
        phoneFormat: "",
        isQueryByLast: "N",
        city: "",
        uuid: "",
        isAsc: "default",
      },
      nStr: "",
      belongingPlaceShow: false, //归属地弹窗
      citycode: "", //城市码，用于组件回显
      areaList,
      priceSortShow: false, //号码筛选弹窗
      priceSortText: "价格排序",
      priceSort: ["默认排序", "由低到高", "由高到低"],
      loading: false, // 是否正在加载数据
      finished: false, // 是否已加载完所有数据
      searchTypeNum: [], //号码类型
      pictureList: [], //背景图
      phoneType: [],
      typeShow: false, //号码筛选弹窗
      activeIdx: null,
    };
  },
  created() {
    let address = this.areaList.province_list;
    const result = {}; // 创建一个空对象用于存储截取的结果
    for (let key in address) {
      if (key != "710000" && key != "810000" && key != "820000") {
        // 截取 name 和 age 属性
        result[key] = address[key];
      }
    }
    this.areaList.province_list = result;
    this.phoneList = [];
    // this.getList();

    // 获取路径
    let url = location.search;
    let urlParams = this.querystring(url);
    console.log(urlParams);
    // let clickid = urlParams.clickid;
    let clickid = "";
    let adid = urlParams.aid;
    let gdtvid = urlParams.gdt_vid;
    let gdtqz = urlParams.qz_gdt;
    localStorage.setItem("adid", adid || null);
    if (urlParams.qz_gdt == null || urlParams.qz_gdt == "") {
      clickid = urlParams.gdt_vid;
    } else {
      clickid = urlParams.qz_gdt;
    }
    localStorage.setItem("clickid", clickid || null);

    if (urlParams.nStr) {
      this.nStr = urlParams.nStr[0];
      this.pageData({ nStr: this.nStr });
    } else {
      // 落地页配置
      this.pageData();
    }
    // queryConfigByPlatform
    queryConfigByPlatform(1, 0).then((res) => {
      if (res.code == 200) {
        this.pictureList = res.data;
      }
    });
    // 获取地理位置
    this.getAddress();
  },
  mounted() {},
  methods: {
    async pageData(data) {
      let res = await details(data);
      if (res.code == 200) {
        // this.homaDetails = res.data;
        this.searchTypeNum = JSON.parse(res.data.phoneType);
        // this.searchHotNum = JSON.parse(res.data.phoneGrade);
        // this.pictureList = JSON.parse(res.data.picture);
        this.params.uuid = res.data.uuid;
        this.phoneType = JSON.parse(res.data.phoneType);
        localStorage.setItem("landingPageId", res.data.id);
      }
    },

    //上拉加载更多
    onLoad() {
      this.params.pageNum++;
      if (this.params.city) {
        this.getList(); //号码列表
      }
    },
    //获取路径中的参数
    // 使用字符串分割和reduce方法获取路径参数值
    querystring(queryStr) {
      const [, query] = queryStr.split("?");
      if (query) {
        return query.split("&").reduce((pre, cur) => {
          const [key, val] = cur.split("=");
          if (pre[key]) {
            pre[key] = [...pre[key], decodeURIComponent(val)];
          } else {
            pre[key] = [decodeURIComponent(val)];
          }
          return pre;
        }, {});
      }
      return {};
    },
    async getAddress() {
      let res = await address();
      if (res.code == 200) {
        this.params.city = res.data.city;
        this.params.pageNum = 1;
        this.phoneList = [];
        this.getList();
      }
    },
    // 号码列表
    async getList() {
      this.finished = false;
      this.loading = true;
      let res = await phoneLists(this.params);

      if (res.code == 200) {
        this.phoneList = this.phoneList.concat(res.data);
        if (!this.phoneList && !res.data) {
          this.$toast("请选择其他城市");
        }
        if (res.data && res.data.length < 10) {
          this.finished = true;
        }
        this.loading = false;
      } else {
        this.finished = true;
        this.loading = false;
      }
    },
    // 全国
    getAll() {
      this.params.city = "全部";
      this.params.pageNum = 1;
      this.phoneList = [];
      this.getList();
    },
    // 本地
    getLocal() {
      this.getAddress();
    },
    // 客服
    getPhone() {
      // 16555551055
      let tel = "17080086677";
      window.location.href = "tel:" + tel;
    },
    // 投诉建议
    complaint() {
      this.$router.push("/complaint");
    },
    // 跳转号码详情
    goDetail(i) {
      this.$router.push("/detail?phone=" + i.phone);
    },
    // 号码搜索
    searchTel() {
      this.params.pageNum = 1;
      this.phoneList = [];
      this.getList();
    },
    // 选择归属地
    getBelongingPlace() {
      this.belongingPlaceShow = true;
    },
    belongingPlaceConfirm(value, index) {
      this.params.city = value[1].name;
      this.params.pageNum = 1;
      this.phoneList = [];
      this.getList();
      this.belongingPlaceShow = false;
    },

    belongingPlaceCancel() {
      this.belongingPlaceShow = false;
    },
    // 价格排序
    getPriceSort() {
      this.priceSortShow = true;
    },
    priceSortonConfirm(value, index) {
      this.priceSortText = value;
      if (this.priceSortText == "默认排序") {
        this.params.isAsc = "default";
      } else if (this.priceSortText == "由低到高") {
        this.params.isAsc = "asc";
      } else {
        this.params.isAsc = "desc";
      }
      this.params.pageNum = 1;
      this.phoneList = [];
      this.getList();
      this.priceSortShow = false;
    },

    priceSortonCancel() {
      this.priceSortShow = false;
    },
    typeActive(i, v) {
      if (this.activeIdx != v) {
        this.activeIdx = v;
        this.params.phoneFormat = i;
      } else {
        this.activeIdx = null;
        this.params.phoneFormat = "";
      }
    },
    typeSearch() {
      this.params.pageNum = 1;
      this.phoneList = [];
      this.getList();
      this.typeShow = false;
    },
  },
};
</script>
<style scoped>
.home {
  min-height: 100vh;
  font-size: 14px;
  /* color: var(--global-font-color);  */
  padding: 12px;
  box-sizing: border-box;
  background: #f5f6fb;
  color: #333;
}
.banner {
  width: 351px;
  height: 124px;
  background: pink;
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;
}
.my-swipe .van-swipe-item {
  width: 351px;
  height: 124px;
}
.mb12 {
  margin-bottom: 12px;
}
.flex {
  display: flex;
  align-items: center;
}
.flexc {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flexb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flexa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.tabsBox {
  width: 351px;
  height: 94px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
}
.tabs {
  width: 32%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  box-sizing: border-box;
}
.search {
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  overflow: hidden;
  padding: 0 12px;
  box-sizing: border-box;
}
.searchIpt {
  border: none;
  outline: none;
  height: 100%;
  flex: 1;
  border-right: 2px solid #f5f6fb;
  margin-right: 6px;
}
.main {
  padding: 12px;
  background: #ffffff;
  border-radius: 8px 8px 0px 0px;
  box-sizing: border-box;
  padding-bottom: 32px;
}
.sort {
  font-size: 16px;
}
.phones {
  flex-wrap: wrap;
}
.lists {
  width: 159px;
  padding: 6px 8px;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 8px 8px;
  position: relative;
}
.liang {
  position: absolute;
  right: 0;
  top: 0;
  width: 16px;
  height: 16px;

  background: var(--global-font-color);
  color: #fff;
  border-radius: 0 6px 0 6px;
  font-size: 12px;
}
.belong {
  font-size: 12px;
  color: #999999;
  margin: 3px 0;
}
.font-color {
  color: var(--global-font-color);
}
.price span {
  font-size: 18px;
  font-weight: 600;
}
.types {
  padding: 12px;
  padding-right: 0;
  padding-bottom: 30px;
}
.typeTitle {
  font-size: 16px;
  margin-bottom: 22px;
  font-weight: 600;
}
.typeItem {
  padding: 2px 10px;
  border-radius: 4px;
  margin-right: 12px;
  margin-bottom: 12px;
  background: #eeeeee;
}
.active {
  background: var(--global-font-color) !important;
  color: #fff !important;
}
.typeBtn {
  padding-right: 12px;
  box-sizing: border-box;
}
.typeBtn div {
  width: 160px;
  height: 40px;
  border-radius: 20px 20px 20px 20px;
  background: var(--global-font-color);
  color: #fff;
  font-size: 16px;
}
</style>
